import { TextField } from '@mui/material';

export default function FilterInput({ filterName, state, setState, ...props }) {
  return (
    <TextField
    sx={{minWidth:'45%', margin:'5px'}}
      placeholder={`Search By ${filterName}`}
      onChange={(e) => setState(e.target.value)}
      onKeyDown={(e) => (e.key === 'Enter' && props.updateFunction ? props.updateFunction() : null)}
      key={props.key}
    />
  );
}
